/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = '';
let routerMode = 'hash';

if (process.env.NODE_ENV == 'development') {
  /*测试环境*/
  // baseUrl = 'http://192.168.1.127:8080/app-api/';//老曹
  // baseUrl = 'http://192.168.1.112:8080/app-api/';//
  baseUrl = 'http://192.168.1.117:8084/app-api/';//测试
  // baseUrl = 'http://114.67.124.186:8081/app-api/';//测试
  // baseUrl = 'https://fast.mrcargo.com/app-api/';
} else {
  //线上
  baseUrl = 'https://fast.mrcargo.com/app-api/';
  // baseUrl = 'http://47.103.37.134:8081/app-api/';//demo 商城测试版
}

export {
  baseUrl,
  routerMode,
}








// WEBPACK FOOTER //
// ./src/config/env.js